import { render } from "./Vulnerabilities.vue?vue&type=template&id=e76abc4e"
import script from "./Vulnerabilities.vue?vue&type=script&lang=js"
export * from "./Vulnerabilities.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__